import React from 'react';
import AreaChartRatioCard from '../../../HOC/Cards/AreaChartRatio';

const InternationDomesticGuestsCard = ({
  graph,
  isDisabled,
  handleOnSampleClick,
  userTailorMarketAccess,
  warningTextComponent,
}: {
  graph;
  isDisabled: boolean;
  handleOnSampleClick: any;
  userTailorMarketAccess: boolean;
  warningTextComponent: any;
}) => {
  const demoData = JSON.stringify({
    domestic: {
      '2022-05-31': 74.1,
      '2022-06-30': 81.8,
      '2023-07-31': 72.0,
      '2023-08-31': 76.4,
      '2023-09-30': 87.8,
      '2022-07-31': 76.4,
      '2022-08-31': 73.6,
      '2022-09-30': 86.1,
      '2023-05-31': 77.0,
      '2022-10-31': 80.0,
      '2023-01-31': 80.0,
      '2023-03-31': 76.5,
      '2023-06-30': 82.2,
      '2023-10-31': 93.5,
      '2023-12-31': 83.3,
      '2022-04-30': 85.3,
      '2023-04-30': 87.7,
      '2021-12-31': 83.3,
      '2022-01-31': 88.2,
      '2022-02-28': 95.8,
      '2023-11-30': 91.7,
      '2022-11-30': 100.0,
      '2022-12-31': 100.0,
      '2022-03-31': 87.5,
      '2023-02-28': 70.0,
    },
    international: {
      '2022-05-31': 25.9,
      '2022-06-30': 18.2,
      '2023-07-31': 28.0,
      '2023-08-31': 23.6,
      '2023-09-30': 12.2,
      '2022-07-31': 23.6,
      '2022-08-31': 26.4,
      '2022-09-30': 13.9,
      '2023-05-31': 23.0,
      '2022-10-31': 20.0,
      '2023-01-31': 20.0,
      '2023-03-31': 23.5,
      '2023-06-30': 17.8,
      '2023-10-31': 6.5,
      '2023-12-31': 16.7,
      '2022-04-30': 14.7,
      '2023-04-30': 12.3,
      '2021-12-31': 16.7,
      '2022-01-31': 11.8,
      '2022-02-28': 4.2,
      '2023-11-30': 8.3,
      '2022-11-30': 0.0,
      '2022-12-31': 0.0,
      '2022-03-31': 12.5,
      '2023-02-28': 30.0,
    },
  });
  return (
    <>
      <AreaChartRatioCard
        title="Domestic vs International Guests"
        data={isDisabled ? demoData : graph.data?.guest.history}
        tooltipContent={'Percentage of Domestic and International Guests booking'}
        isDisabled={isDisabled}
        handleOnSampleClick={handleOnSampleClick}
        userTailorMarketAccess={userTailorMarketAccess}
        parent="domestic_vs_intl_guests"
        warningTextComponent={warningTextComponent}
      />
    </>
  );
};

export default InternationDomesticGuestsCard;
